import React, { useState } from "react";
import { useLocation } from "react-router-dom";

import PostLoginLayout from "../components/layouts/PostLoginLayout";
import ClientsConfigurationsComponent from "../components/ClientsConfigurationsComponent";

const ClientsConfigurations = () => {
  const location = useLocation();

  let ClientsConfigurationsContainer = <ClientsConfigurationsComponent />;

  return <PostLoginLayout childComponent={ClientsConfigurationsContainer} noLeftPanel={false} loader={false}/>;
};

export default ClientsConfigurations;
